.subTable {
  width: 1450px;
  padding-left: 48px;
}

.attentionRow {
  background-color: #ffeaf2; // light pink
}
